import {http} from "@/plugins/axios"

    function findAll () {
        return http
            .get("/sumulas")
            .then((response) => response.data || [])
            .catch((e) => {
                console.error(e);
                throw e; // a tela decide o que mostrar (aviso de indisponibilidade)
            });
    }

    function buscar (id) {

        return http
            .get(`sumulas/${id}`)
            .then(res => res.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function buscarFiltro (filtro) {

        return http
            .get("sumulas/filtro", {
                params: {
                    numero: filtro.numero,
                    enunciado: filtro.enunciado,
                }
            })
            .then(res => res.data || [])
            .catch((e) => {
                console.error(e);
                throw e; // a tela decide o que mostrar (aviso de indisponibilidade)
            });
    }

    function salvar(sumula) {
        if (sumula.sumulaId == null) {
            
            return http
                .post("sumulas/", sumula)
                .then((response) => response.data)
                .catch(err => console.error(err.message));
        } else {
            return http
                .put(`sumulas/${sumula.sumulaId}`, sumula)
                .then(response => response.data)
                .catch(err => console.error(err.message));
        }
    
    }
    
    function excluir(id){
        return http
            .delete(`/sumulas/${id}`)
            .then(res => {
                if(res.status === 204){
                    alert("Registro excluído com sucesso.")
                    return "ok"
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Erro na solicitação.")
                return "erro"
            });
    }

    let service = {}
    service.findAll = findAll
    service.buscar = buscar
    service.buscarFiltro = buscarFiltro
    service.salvar = salvar
    service.excluir = excluir

    export default service
